import React, { Component } from 'react';


import { Form, Input, InputNumber, Button, Modal, Select, Divider, Switch, Icon } from 'antd';
import { withState } from 'recompose';
import ParkinglocationSelect from './ParkinglocationSelect';
const FormItem = Form.Item;
const { Option } = Select;

class ParkingConnlocationsSettingForm extends Component {

    state = {
        modalVisible: false,
        confirmDirty: false,
        coreParkingLocationID: null,
    }

    form = null;



    componentWillReceiveProps(nextProps) {
        this.setState({
            modalVisible: nextProps.modalVisible
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                !values.port && delete values.port;
                this.props.onSuccess(this.props.form, values);
            }
        });
    }


    renderForm() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const driverType = (typeof getFieldValue('driverType') === 'undefined') ?
            this.props.initialValues && this.props.initialValues.driverType
                ? this.props.initialValues.driverType
                : undefined : getFieldValue('driverType');

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 11 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 },
            },
        };

        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 22,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };

        return (
            <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
                <FormItem
                    {...formItemLayout}
                    label="Lokalita" >
                    {getFieldDecorator('coreParkingLocationId', {
                        initialValue: this.props.initialValues && this.props.initialValues.coreParkingLocationId
                            ? this.props.initialValues.coreParkingLocationId
                            : undefined,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <ParkinglocationSelect onChange={(value) => { this.props.form.setFieldsValue({ coreParkingLocationId: value }); }} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Driver" >
                    {getFieldDecorator('driverType', {
                        initialValue: this.props.initialValues && this.props.initialValues.driverType
                            ? this.props.initialValues.driverType
                            : undefined,
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <Select placeholder='Zvolte driver'>
                            <Select.Option value="Cross-PS4">Cross-PS4</Select.Option>
                            <Select.Option value="Green-Rest-5.4">Green-Rest-5.4</Select.Option>
                            <Select.Option value="Green-Rest-5.6">Green-Rest-5.6</Select.Option>
                            <Select.Option value="Green-WebInterface-5.3.0">Green-WebInterface-5.3.0</Select.Option>
                            <Select.Option value="Invipo-Parking-V2">Invipo-Parking-V2</Select.Option>
                            <Select.Option value="ASParking-V1">ASParking-V1</Select.Option>
                            <Select.Option value="SKIdata">SKIdata</Select.Option>
                            <Select.Option value="Parkinto-V1">Parkinto-V1</Select.Option>
                        </Select>
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Typ" >
                    {getFieldDecorator('requestType', {
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                        initialValue: this.props.initialValues && this.props.initialValues.requestType
                            ? this.props.initialValues.requestType
                            : null,
                    })(
                        <Select placeholder='Zvolte typ'>
                            <Select.Option value="PULL">PULL</Select.Option>
                            <Select.Option value="PUSH">PUSH</Select.Option>
                        </Select>
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Jméno">
                    {getFieldDecorator('name', {
                        initialValue: this.props.initialValues && this.props.initialValues.name
                            ? this.props.initialValues.name
                            : null,
                        rules: [{
                            type: 'string', message: 'Položka musí být string!',
                        }, {
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <Input />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Popis">
                    {getFieldDecorator('description', {
                        initialValue: this.props.initialValues && this.props.initialValues.description
                            ? this.props.initialValues.description
                            : '',
                        rules: [{
                            type: 'string', message: 'Položka musí být string!',
                        }],
                    })(
                        <Input.TextArea
                            autosize={{
                                maxRows: 7
                            }} />
                    )}
                </FormItem>
                {(driverType != 'SKIdata') && (
                    <FormItem
                        {...formItemLayout}
                        label="Protokol" >
                        {getFieldDecorator('protocol', {
                            rules: [{
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }],
                            initialValue: this.props.initialValues && this.props.initialValues.protocol
                                ? this.props.initialValues.protocol
                                : null,
                        })(
                            <Select placeholder='Zvolte protokol'>
                                <Select.Option value="http">http</Select.Option>
                                <Select.Option value="https">https</Select.Option>
                            </Select>
                        )}
                    </FormItem>
                )}
                {(driverType != 'SKIdata') && (
                    <FormItem
                        {...formItemLayout}
                        label="Adresa Url" >
                        {getFieldDecorator('ipAddress', {
                            rules: [{
                                type: 'string', message: 'Položka musí být string!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }],
                            initialValue: this.props.initialValues && this.props.initialValues.ipAddress
                                ? this.props.initialValues.ipAddress
                                : null,
                        })(
                            <Input />
                        )}
                    </FormItem>
                )}

                {(driverType == 'Cross-PS4' || driverType == 'Green-Rest-5.4' || driverType == 'Green-Rest-5.6' || driverType == 'Green-WebInterface-5.3.0' || driverType == 'ASParking-V1') && (
                    <FormItem
                        {...formItemLayout}
                        label="Port" >
                        {getFieldDecorator('port', {
                            rules: [{
                                type: 'number', message: 'Položka musí být číslo!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }
                            ],
                            initialValue: this.props.initialValues && this.props.initialValues.port
                                ? this.props.initialValues.port
                                : null,
                        })(
                            <InputNumber min={0} max={65535} />
                        )}
                    </FormItem>
                )}
                {(driverType == 'Cross-PS4' || driverType == 'Green-Rest-5.4' || driverType == 'Green-Rest-5.6' || driverType == 'Green-WebInterface-5.3.0' || driverType == 'ASParking-V1' || driverType == 'SKIdata') && (
                    <FormItem
                        {...formItemLayout}
                        label="ParkId" >
                        {getFieldDecorator('parkId', {
                            rules: [{
                                type: 'number', message: 'Položka musí být číslo!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }
                            ],
                            initialValue: this.props.initialValues && this.props.initialValues.parkId !== null && this.props.initialValues.parkId !== undefined
                                ? this.props.initialValues.parkId
                                : (driverType === 'Cross-PS4' ? "1" : "-"),
                        })(
                            <InputNumber min={0} max={65535} />
                        )}
                    </FormItem>
                )}
                {(driverType == 'Invipo-Parking-V2' || driverType == 'SKIdata') && (
                    <FormItem
                        {...formItemLayout}
                        label="Area" >
                        {getFieldDecorator('area', {
                            rules: [{
                                type: 'string', message: 'Položka musí být string!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }
                            ],
                            initialValue: this.props.initialValues && this.props.initialValues.area
                                ? this.props.initialValues.area
                                : null,
                        })(
                            <Input />
                        )}
                    </FormItem>
                )}
                {(driverType == 'SKIdata') && (
                    <FormItem
                        {...formItemLayout}
                        label="FacilityId" >
                        {getFieldDecorator('facilityId', {
                            rules: [{
                                type: 'number', message: 'Položka musí být number!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }
                            ],
                            initialValue: this.props.initialValues && this.props.initialValues.facilityId
                                ? this.props.initialValues.facilityId
                                : null,
                        })(
                            <InputNumber min={0} max={773001300} />
                        )}
                    </FormItem>
                )}
                {(driverType == 'Green-Rest-5.6' || driverType == 'Invipo-Parking-V2') && (
                    <FormItem
                        {...formItemLayout}
                        label="Token" >
                        {getFieldDecorator('token', {
                            rules: [{
                                type: 'string', message: 'Položka musí být string!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }],
                            initialValue: this.props.initialValues && this.props.initialValues.token
                                ? this.props.initialValues.token
                                : null,
                        })(
                            <Input />
                        )}
                    </FormItem>
                )}
                {(driverType == 'Cross-PS4' || driverType == 'Green-Rest-5.4' || driverType == 'Parkinto-V1') && (
                    <FormItem
                        {...formItemLayout}
                        label="Login" >
                        {getFieldDecorator('login', {
                            rules: [{
                                type: 'string', message: 'Položka musí být string!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }
                            ],
                            initialValue: this.props.initialValues && this.props.initialValues.login
                                ? this.props.initialValues.login
                                : null,
                        })(
                            <Input />
                        )}
                    </FormItem>
                )}
                <FormItem
                    {...formItemLayout}
                    label="Aktivní">
                    {getFieldDecorator('active', {
                        valuePropName: 'checked',
                        initialValue: this.props.initialValues && this.props.initialValues.active
                            ? this.props.initialValues.active
                            : false,
                    })(
                        <Switch
                            checkedChildren={<Icon type="check" />}
                            unCheckedChildren={<Icon type="close" />} />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Upozornění">
                    {getFieldDecorator('reportsEnabled', {
                        valuePropName: 'checked',
                        initialValue: this.props.initialValues && this.props.initialValues.reportsEnabled
                            ? this.props.initialValues.reportsEnabled
                            : false,
                    })(
                        <Switch
                            checkedChildren={<Icon type="check" />}
                            unCheckedChildren={<Icon type="close" />} />
                    )}
                </FormItem>
                <FormItem {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit">Uložit</Button>
                </FormItem>
            </Form>
        );
    }

    render() {
        if (this.props.type && this.props.type === 'modal') {
            return (
                <Modal
                    width={700}
                    title="Nastavení lokality"
                    visible={this.state.modalVisible}
                    maskClosable={false}
                    onCancel={() => {
                        this.props.onModalCancel(this.props.form);
                        this.setState({ modalVisible: false });
                    }}
                >
                    {this.renderForm()}
                </Modal>
            )
        } else {
            return this.renderForm();
        }
    }
}

const WrappedParkingConnlocationsSettingForm = Form.create()(ParkingConnlocationsSettingForm);

export default WrappedParkingConnlocationsSettingForm;


// WEBPACK FOOTER //
// ./src/components/ParkingConnlocationsSettingForm.js